var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.user && !_vm.preventButton)?_c('v-btn',{staticClass:"blue--text ",attrs:{"text":""},on:{"click":function($event){return _vm.goLogin()}}},[_vm._v(" "+_vm._s(_vm.$t('signInButtonText'))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }